import {cloneDeep} from "lodash"
import qs from "qs"
import {APIRequestConfig} from "../.."

export default function addHeaders(config: APIRequestConfig = {}, etag = "") {
  const options: APIRequestConfig = cloneDeep(config)

  if (!options.headers) {
    options.headers = {}
  }

  if (etag) {
    options.headers["If-Match"] = etag
  }

  if (config.addCSRF) {
    const csrfElement = document.querySelector<HTMLMetaElement>('meta[name="csrf"]')
    if (csrfElement) {
      options.headers["csrf-token"] = csrfElement.content
    }
  }

  // Check if this is a FormData upload (for GraphQL file uploads)
  if (config.data && (config.data instanceof FormData || config.data?.constructor?.name === "FormData")) {
    // Remove any existing content-type headers that might interfere
    delete options.headers["content-type"]
    delete options.headers["Content-Type"]
    delete options.headers["CONTENT-TYPE"]

    // Force Axios to treat this as FormData by setting specific options
    options.transformRequest = [(data) => data] // FormData as-is

    // Ensure proper headers for multipart
    options.headers.Accept = "*/*"
  }

  if (!options.paramsSerializer) {
    options.paramsSerializer = (params: any) => qs.stringify(params, {arrayFormat: "repeat", skipNulls: true})
  }

  return options
}
